
class HXFormFieldDropdownColor extends HXFormFieldDropdown {
    // existiert nur, damit auch hier mit dem full qualified name zugegriffen werden kann
}